// extracted by mini-css-extract-plugin
export default {"image":"NL1s8t"};